import { formatNumber } from '@/common/utils/format';

const getNumber = (value) => Number(value || 0);

export const buildContentSummaryItems = ({ data = {}, resolveOrganizationPath }) => [
  {
    href: resolveOrganizationPath('/ip-creator/seed-plans'),
    rows: [{ label: '已规划', value: formatNumber(getNumber(data.seedPlans?.total)) }],
    title: '创作规划',
  },
  {
    href: resolveOrganizationPath('/ip-creator/hot-pots'),
    rows: [
      { label: '已采集', value: formatNumber(getNumber(data.hotPots?.total)) },
      { label: '已入选', value: formatNumber(getNumber(data.hotPots?.selected)) },
    ],
    title: '热点采集',
  },
  {
    href: resolveOrganizationPath('/ip-creator/fact-anchors'),
    rows: [{ label: '已搜集', value: formatNumber(getNumber(data.factAnchors?.total)) }],
    title: '材料搜集',
  },
  {
    href: resolveOrganizationPath('/ip-creator/topic-lens'),
    rows: [
      { label: '已选题', value: formatNumber(getNumber(data.topicLens?.total)) },
      { label: '已入选', value: formatNumber(getNumber(data.topicLens?.selected)) },
    ],
    title: '选题策划',
  },
  {
    href: resolveOrganizationPath('/ip-creator/article-arcs'),
    rows: [{ label: '已创作', value: formatNumber(getNumber(data.articleArcs?.total)) }],
    title: '文章创作',
  },
  {
    href: resolveOrganizationPath('/ip-creator/script-arcs'),
    rows: [{ label: '已脚本', value: formatNumber(getNumber(data.scriptArcs?.total)) }],
    title: '视频脚本',
  },
];
